"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayPeriodDailyBreakdown = exports.getDailyScheduledDuration = exports.getDailyWorkedResults = exports.getScheduleDateMap = exports.getTimeSegmentDateMap = exports.getPunchesDateMap = void 0;
const luxon_1 = require("luxon");
const DateManagement_1 = require("../../../utils/DateManagement");
const useDaysWithUpt_1 = require("../../../hooks/useDaysWithAttention/useDaysWithUpt");
const getPunchesDateMap = (punchesResponse) => {
    const punchesDateMap = new Map();
    punchesResponse === null || punchesResponse === void 0 ? void 0 : punchesResponse.punchesTimeSegments.forEach((segment) => {
        var _a;
        const segmentStart = segment.startDateTime || segment.endDateTime;
        const date = luxon_1.DateTime.fromISO(segmentStart).toISODate();
        if (punchesDateMap[date]) {
            (_a = punchesDateMap[date]) === null || _a === void 0 ? void 0 : _a.push(segment);
        }
        else {
            punchesDateMap[date] = [segment];
        }
    });
    return punchesDateMap;
};
exports.getPunchesDateMap = getPunchesDateMap;
const getTimeSegmentDateMap = (punchesResponse) => {
    const timeSegmentTypesDateMap = new Map();
    punchesResponse === null || punchesResponse === void 0 ? void 0 : punchesResponse.timeSegmentDailyAggregation.forEach((segment) => {
        var _a;
        const date = luxon_1.DateTime.fromFormat(segment.date, 'M/dd/yyyy').toISODate();
        if (timeSegmentTypesDateMap[date]) {
            (_a = timeSegmentTypesDateMap[date]) === null || _a === void 0 ? void 0 : _a.push(segment);
        }
        else {
            timeSegmentTypesDateMap[date] = [segment];
        }
    });
    return timeSegmentTypesDateMap;
};
exports.getTimeSegmentDateMap = getTimeSegmentDateMap;
const getScheduleDateMap = (scheduleResponse) => {
    const scheduleDateMap = new Map();
    scheduleResponse === null || scheduleResponse === void 0 ? void 0 : scheduleResponse.schedules.forEach((schedule) => {
        var _a;
        const date = luxon_1.DateTime.fromISO(schedule.startAt).toISODate();
        if (scheduleDateMap[date]) {
            (_a = scheduleDateMap[date]) === null || _a === void 0 ? void 0 : _a.push(schedule);
        }
        else {
            scheduleDateMap[date] = [schedule];
        }
    });
    return scheduleDateMap;
};
exports.getScheduleDateMap = getScheduleDateMap;
const getDailyWorkedResults = (punchesDateMap, timeSegmentTypesDateMap, date, isTimecardUPTAnomalyEnabled) => {
    var _a, _b;
    const workedResults = {
        durationMin: 0,
        anomaly: false
    };
    punchesDateMap[date] &&
        ((_a = punchesDateMap[date]) === null || _a === void 0 ? void 0 : _a.forEach((segment) => {
            if (segment.startDateTime && segment.endDateTime) {
                workedResults.durationMin += (0, DateManagement_1.getMinutesDifference)(segment.startDateTime, segment.endDateTime);
            }
            else {
                workedResults.anomaly = true;
            }
        }));
    isTimecardUPTAnomalyEnabled &&
        timeSegmentTypesDateMap[date] &&
        ((_b = timeSegmentTypesDateMap[date]) === null || _b === void 0 ? void 0 : _b.forEach((segment) => {
            if (useDaysWithUpt_1.uptPaycodes.includes(segment.timeSegmentTypeId)) {
                workedResults.anomaly = true;
            }
        }));
    return workedResults;
};
exports.getDailyWorkedResults = getDailyWorkedResults;
const getDailyScheduledDuration = (scheduleDateMap, date) => {
    var _a;
    let durationMin = 0;
    (_a = scheduleDateMap[date]) === null || _a === void 0 ? void 0 : _a.forEach((shift) => {
        var _a;
        if (shift.duration) {
            durationMin += luxon_1.Duration.fromISO(shift.duration).shiftTo('minutes').minutes;
        }
        else {
            durationMin += (0, DateManagement_1.getMinutesDifference)(shift.startAt, shift.endAt);
            (_a = shift.metadata.breaks) === null || _a === void 0 ? void 0 : _a.forEach((shiftBreak) => {
                durationMin -= (0, DateManagement_1.getMinutesDifference)(shiftBreak.startAt, shiftBreak.endAt);
            });
        }
    });
    return durationMin;
};
exports.getDailyScheduledDuration = getDailyScheduledDuration;
const getPayPeriodDailyBreakdown = (startTime, endTime, punchesResponse, scheduleResponse, isTimecardUPTAnomalyEnabled) => {
    const dailyBreakdown = {};
    const punchesDateMap = (0, exports.getPunchesDateMap)(punchesResponse);
    const timeSegmentTypesDateMap = (0, exports.getTimeSegmentDateMap)(punchesResponse);
    const scheduleDateMap = (0, exports.getScheduleDateMap)(scheduleResponse);
    let curDate = luxon_1.DateTime.fromISO(startTime);
    let curDateISO = curDate.toISODate();
    const endDate = luxon_1.DateTime.fromISO(endTime);
    while (curDate <= endDate) {
        const worked = (0, exports.getDailyWorkedResults)(punchesDateMap, timeSegmentTypesDateMap, curDateISO, isTimecardUPTAnomalyEnabled);
        const scheduledMin = (0, exports.getDailyScheduledDuration)(scheduleDateMap, curDateISO);
        dailyBreakdown[curDateISO] = {
            workedMinutes: worked.durationMin,
            anomaly: worked.anomaly,
            scheduledMinutes: scheduledMin
        };
        curDate = curDate.plus({ days: 1 });
        curDateISO = curDate.toISODate();
    }
    return dailyBreakdown;
};
exports.getPayPeriodDailyBreakdown = getPayPeriodDailyBreakdown;
